import { pxToRem } from '@deltek/specification-client/core/Utilities/unitUtils'
import { Theme, makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme: Theme) => ({
    header: {
        padding: theme.spacing(1.5, 2),
        flex: 1,
    },
    properties: {
        backgroundColor: '#F2F2F2',
        height: '100%',
    },
    headerButtonSpacing: { marginRight: theme.spacing(2.5) },
    headerLabel: {
        ...theme.typography.body1,
        margin: theme.spacing(0, 0, 0.5, 0.5),
        display: 'flex',
    },
    headerButtons: {
        '& button': {
            padding: theme.spacing(1.25, 2.25),
            width: 'auto',
            height: 41,
            backgroundColor: '#5E5F61',
            borderRadius: 100,
            color: theme.palette.common.white,
            ...theme.typography.h6,
            lineHeight: 'inherit',
            '&:hover': {
                backgroundColor: '#5E5F61',
            },
        },
    },
    actionButtonContainer: {
        padding: theme.spacing(0, 0.5, 0.5, 0.5),
        '& button': {
            ...theme.typography.h6,
            padding: theme.spacing(1.25, 2),
            borderRadius: 100,
            height: 41,
        },
        '& button.MuiButton-contained.Mui-disabled ': {
            border: '1px solid #0098D6',
            color: '#5E5F61',
        },
    },
    headerButtonContainer: {
        flex: 1,
        flexWrap: 'nowrap',
        '& >div.MuiGrid-item': { margin: '0px 12px' },
    },
    mfgUpdateButton: {
        marginTop: theme.spacing(3.5),
    },

    editPageButtonContainer: {
        '&>span': {
            ...theme.typography.body1,
            marginBottom: theme.spacing(0.5),
            display: 'flex',
        },
        '& button': {
            backgroundColor: '#0098D6',
            color: theme.palette.secondary.light,
            '&:hover': {
                backgroundColor: theme.palette.primary,
            },
        },
    },
    dangerButtons: {
        '&>span': {
            ...theme.typography.body1,
            marginBottom: theme.spacing(0.5),
            display: 'flex',
        },
        '& button': {
            backgroundColor: '#d3455b',
            color: theme.palette.secondary.light,
            '&:hover': {
                backgroundColor: '#e9a2ad',
            },
        },
    },
    rowContainer: {
        backgroundColor: theme.palette.secondary.light,
    },
    cancelButtonContainer: {
        '& button': {
            border: `1px solid ${theme.palette.primary.main}`,
        },
    },
    savePublishMarginTop: {
        '& button': {
            marginTop: theme.spacing(3.5),
        },
    },
    headerButtonWrapper: {
        '@media (min-width: 1280px)': {
            flex: 4,
        },
    },
    addProductButtonContainer: {
        '&>span': {
            ...theme.typography.body1,
            marginBottom: theme.spacing(0.5),
            display: 'flex',
        },
        '& button': {
            backgroundColor: '#33B55B',
            color: theme.palette.secondary.light,
            '&:hover': {
                backgroundColor: '#268e46',
            },
        },
    },
    optionalButtonContainer: {
        '& > div:last-child': {
            marginRight: pxToRem(15),
        },
        '@media (min-width: 1164px) and (max-width: 1280px)': {
            flexDirection: 'column',
            alignItems: 'flex-end',
            '& > div:not(:first-child) > div': {
                marginTop: pxToRem(10),
            },
        },

        flexDirection: 'row',
        alignItems: 'flex-end',
        marginBottom: theme.spacing(1),
    },
}))

export default useStyles
